//  Client\client-vite\src\main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Toaster } from "sonner";
import "./index.css";
import "./css/globals.css";

import { AuthProvider } from "@/providers/AuthProvider";
import { ThemeProvider } from "./providers/theme-provider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <App />
        <Toaster richColors position="top-right" />
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);
